// extracted by mini-css-extract-plugin
export default {"gridContainer":"AdminConfig_gridContainer__lHEfO"};